// const useCameraPermission = () => {
//   function cameraPermissonPromise() {
//     return new Promise(async (resolve, reject) => {});
//   }
//   return cameraPermissonPromise;
// };

// export default useCameraPermission;
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {showAlert} from '../../actions/AlertActions';

const useCameraPermission = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  
  function cameraPermissonPromise() {
    return new Promise(async (resolve, reject) => {
      try {
        // چک کن که browser از getUserMedia پشتیبانی می‌کنه
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // برای iOS PWA، باید constraints رو به شکل خاصی تعریف کنیم
          const constraints = {
            video: {
              facingMode: 'environment', // دوربین پشتی
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          };

          // درخواست دسترسی به camera
          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          
          // stream رو ببند تا resource آزاد بشه
          stream.getTracks().forEach(track => track.stop());
          
          // اگر موفق بود
          resolve(true);
        } else {
          // browser از camera پشتیبانی نمی‌کنه
          dispatch(
            showAlert({
              id: 'AlertBox',
              modalProps: {
                icon: 'redExclamation',
                title: t('camera_permission'),
                message: t('camera_permission_deny'),
              },
            }),
          );
          reject(new Error('Camera not supported'));
        }
      } catch (error) {
        console.log('Camera permission error:', error);
        
        // اگر کاربر permission رد کرد یا خطای دیگه
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t('camera_permission'),
              message: t('camera_permission_deny'),
            },
          }),
        );
        reject(error);
      }
    });
  }
  return cameraPermissonPromise;
};

export default useCameraPermission;